export default (state, { payload: sortOption }) => ({
  ...state,
  ...sortOption
});
